import { Component, OnInit,HostListener  } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb';
import { ActivatedRoute } from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer,SafeResourceUrl} from '@angular/platform-browser';
@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrls: ['./sites.component.scss']
})
export class SitesComponent implements OnInit {
  public id: string;

  constructor(private BreadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,private http:HttpClient,
    private sanitizer:DomSanitizer) { }

  breadcrumbItems = [
    {
      label: 'Home',
      active: false,
      url: "/home",
    },
    {
      label: 'Sites',
      active: false,
      url: "/sites/point-of-sale",
    },
  ];
  siteHTML;
  urlSafe: SafeResourceUrl;
  site = 'Point of sale'
  url = 'https://www.eatos.com/point-of-sale/'
  public getScreenWidth: any;
  public getScreenHeight: any
  @HostListener('window:resize', ['$event'])


  onWindowResize() {
    this.getScreenHeight = window.innerHeight+"px";
  }

  ngOnInit(): void {
    this.getScreenHeight = window.innerHeight+"px";

    this.id = this.route.snapshot.paramMap.get('id');

    switch (this.id) {
      case 'point-of-sale':
        this.site = 'Point of Sale'
        this.url = "https://www.pointofsale.site/"
        break
      case 'point-of-purchase':
        this.site = 'Point of Purchase'
        this.url = "https://www.pointofpurchase.org/"
        break
      case 'online-ordering-and-delivery':
        this.site = 'Online Ordering and Delivery'
        this.url = "https://www.orderos.com/"
        break
      case 'kitchen-display-system':
        this.site = 'Kitchen Display System'
        this.url = "https://www.kitchendisplaysystem.net/ "
        break
      case 'self-serving-kiosk':
        this.site = 'Self Serving Kiosk'
        this.url = "https://www.kioskos.co/"
        break
      case 'workforce-management':
        this.site = 'Workforce Management'
        this.url = "https://www.workforceos.net/"
        break
      case 'customer-facing-display':
        this.site = 'Customer Facing Display'
        this.url = "https://www.customerfacingdisplay.com/"
        break
      case 'table-side-order-and-ay':
        this.site = 'Table-side Order and Pay'
        this.url = "https://www.orderattable.in/"
        break
      case 'analytics-and-Reporting':
        this.site = 'Analytics and Reporting'
        this.url = "https://www.reportingandanalytics.com/"
        break

    }
    var sel =
    {
      label: this.site,
      active: true,
      url: "",
    }
    this.breadcrumbItems.push(sel)
    this.BreadcrumbService.setValue(this.breadcrumbItems);

    // this.http.get('https://kissht.com/',{responseType:'text'}).subscribe(res=>{
    //   this.siteHTML = this.sanitizer.bypassSecurityTrustHtml(res);
    // })

    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }


}
